import type { CityConfig } from "../city-template/types";

export const aspenConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { label: "Birth & Death Certificates — Colorado Dept of Public Health Vital Records", href: "https://cdphe.colorado.gov/vital-records", description: "Official Colorado vital records office in Denver" },
    { label: "Marriage Licenses — Pitkin County Clerk", href: "https://www.pitkincounty.com/", description: "Pitkin County Clerk — marriage license issuance" },
    { label: "Divorce Records — Pitkin County Clerk", href: "https://www.pitkincounty.com/", description: "Pitkin County Clerk — divorce decree records" },
    { label: "VitalChek — Order Vital Records Online", href: "https://www.vitalchek.com/", description: "Official partner of CDPHE for online vital record orders" },
  ],
  city: "Aspen",
  state: "Colorado",
  stateAbbr: "CO",
  slug: "aspen",
  route: "/aspen",
  title: "Emergency Passport Aspen, CO — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency passport and expedited passport services in Aspen, Colorado — as fast as 24 hours. Same-day courier processing for Aspen, Snowmass Village, Basalt, and all Roaring Fork Valley travelers. A+ BBB rated, registered State Dept. courier. No office visit required.",
  h1: "Emergency & Expedited Passport Services in Aspen, CO",
  heroSubtitle: "International ski trip to the Alps with a last-minute passport issue? Private jet departing ASE and your passport just expired? We help Aspen residents — from Red Mountain homeowners to Snowmass families to Roaring Fork Valley professionals — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates typically 30–100% lower than other passport courier resellers. As fast as 24 hours. A+ BBB rated.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aspen%20Colorado%20scenic%20winter%20mountain%20landscape%20with%20the%20iconic%20Maroon%20Bells%20twin%20peaks%20reflected%20in%20a%20pristine%20alpine%20lake%2C%20snow%20covered%20peaks%20under%20bright%20blue%20sky%2C%20the%20historic%20downtown%20Aspen%20with%20Victorian%20architecture%20and%20boutique%20shops%20along%20pedestrian%20streets%2C%20luxury%20ski%20resort%20atmosphere%2C%20crisp%20winter%20light%20with%20long%20shadows%2C%20professional%20landscape%20photography%2C%20no%20visible%20text%20or%20people%2C%20cinematic%20wide%20angle%20view%20with%20rich%20contrast&width=1800&height=700&seq=aspen-hero-001&orientation=landscape",
  heroImageAlt: "Aspen Colorado with Maroon Bells mountain peaks and downtown Victorian architecture",
  geoPosition: "39.1911;-106.8175",
  geoPlacename: "Aspen, Colorado",
  lastModified: "2026-06-05",
  regionalAgency: {
    name: "Colorado Passport Agency",
    address: "7245 S Havana Street Suite B-600, Centennial, CO 80112",
    distance: "Approximately 160 miles east via I-70 — about 3.5 hours",
  },
  nearbyCitiesZips: [
    { name: "Aspen", zips: "81611, 81612" },
    { name: "Snowmass Village", zips: "81615" },
    { name: "Snowmass", zips: "81654" },
    { name: "Basalt", zips: "81621" },
    { name: "El Jebel", zips: "81623" },
    { name: "Carbondale", zips: "81623" },
    { name: "Woody Creek", zips: "81656" },
    { name: "Glenwood Springs", zips: "81601, 81602" },
    { name: "Redstone", zips: "81623" },
    { name: "Marble", zips: "81623" },
    { name: "Crested Butte", zips: "81224, 81225" },
    { name: "Gunnison", zips: "81230, 81231" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier service for urgent Aspen international departures via ASE or DEN" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved — no need to drive 160 miles to Denver" },
    { icon: "ri-flight-takeoff-line", title: "ASE & EGE Airport Service", desc: "Same-day courier for Aspen-Pitkin County and Eagle County Regional airports" },
    { icon: "ri-mail-send-line", title: "Overnight Shipping", desc: "Prepaid labels from any UPS or FedEx in the Roaring Fork Valley" },
  ],
  internalLinks: [
    { name: "Expedited passport in Denver, CO", route: "/denver" },
    { name: "Emergency passport help in Vail, CO", route: "/vail" },
    { name: "Fast passport renewal in Glenwood Springs area", route: "/aspen" },
    { name: "Urgent passport services for Snowmass Village", route: "/aspen" },
    { name: "Colorado passport services overview", route: "/states/colorado" },
    { name: "Passport courier services in Basalt and Carbondale", route: "/aspen" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Aspen remotely via secure registered courier. Our couriers hand-deliver your documents directly to U.S. Department of State processing facilities. Aspen's high-country location — 160 miles from the Colorado Passport Agency — makes our courier service especially valuable. Skip the 3.5-hour drive over mountain passes and let us handle everything.",
  fpcOfficeAddress: "370 17th St, Denver, CO 80202",
  fpcOfficeDistance: "Serving all of Pitkin County, the Roaring Fork Valley, and the upper Crystal River Valley",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Aspen and the Roaring Fork Valley. From the slopes of Aspen Mountain and Aspen Highlands to the village at Snowmass, from Buttermilk to the residential neighborhoods of Red Mountain and the West End — we serve every corner of Aspen and the surrounding mountain communities.",
  nearbyCitiesIntro: "We serve Aspen and all nearby Roaring Fork Valley communities including Snowmass Village, Basalt, El Jebel, Carbondale, Glenwood Springs, Redstone, and Marble. We also serve Crested Butte, Gunnison, and the upper Crystal River Valley.",
  howItWorksIntro: "Most Aspen travelers complete everything online and ship documents via overnight courier. Our registered couriers handle the State Department delivery — no need to drive 160 miles to Denver over mountain passes.",
  mistakesIntro: "Aspen is a world-class international destination with travelers heading to Europe for ski season and private jet departures from ASE. Here are the most common passport mistakes we see from Aspen-area travelers.",
  testimonialsIntro: "Aspen travelers — from winter ski vacationers to summer festival-goers to year-round Roaring Fork Valley residents — trust us when their departure is days away.",
  faqIntro: "Have questions about expedited passports in Aspen, CO? Here are the most common ones we hear from Roaring Fork Valley travelers.",
  statePageRoute: "/states/colorado",
  statePageName: "Colorado",
  dmvWebsite: "https://dmv.colorado.gov",
  dmvLabel: "Colorado DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Must drive to Denver (3.5 hours each way)", "Weather-dependent I-70 mountain corridor travel"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "No Denver drive required — ship from Aspen", "Perfect for international ski trips and European vacations", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Faster than self-service", "Good for planned seasonal travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For Aspen travelers with immediate departure needs — as fast as 24 hours. Our couriers provide the fastest passport service available without the 3.5-hour drive to Denver.",
      bullets: ["24–48 hour turnaround available", "Private jet (ASE) and Denver (DEN) departure support", "European ski season travel expertise"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for Aspen adults with a passport issued within the last 15 years. Skip the post office and let our couriers handle everything.",
      bullets: ["No clerk visit required for most renewals", "Mail-in or courier options", "Returned to your Roaring Fork Valley address"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport (First-Time)",
      description: "First-time passport application for Aspen residents and Roaring Fork Valley families — including seasonal residents and new citizens.",
      bullets: ["Acceptance facility scheduling in Aspen or Glenwood Springs", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Emergency passport replacement for Aspen residents who lost their passport before international travel — ski season or summer festival.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement in 24–48 hours"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 — for Aspen and Roaring Fork Valley families traveling internationally with kids.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change Passport",
      description: "Passport name correction after marriage, divorce, or legal name changes for Aspen and Pitkin County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Aspen CO", description: "Urgent passport processing for Aspen Colorado travelers with immediate departure needs from ASE or DEN." },
    { name: "Expedited Passport Renewal Aspen CO", description: "Fast passport renewal for Aspen Colorado residents with a previously-issued passport." },
    { name: "First-Time Passport Aspen CO", description: "New passport application services for Aspen Colorado residents applying for their first passport." },
    { name: "Child Passport Aspen CO", description: "Minor passport services for Aspen Colorado families with children under 16." },
  ],
  testimonials: [
    {
      name: "James W.",
      location: "Aspen, CO — Red Mountain",
      rating: 5,
      text: "Private jet to St. Moritz departing in 4 days and realized my passport had expired. Fast Passport Center got my renewal done in 2 days. Shipped from the UPS Store in Aspen and everything was flawless. Absolutely saved our ski trip.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Catherine L.",
      location: "Snowmass Village, CO",
      rating: 5,
      text: "Family trip to Chamonix over winter break. Three passports — one renewal and two first-time for our kids. Done in 5 days. The courier service is a game-changer for mountain communities far from Denver.",
      service: "Family Passport Bundle",
    },
    {
      name: "Mark T.",
      location: "Basalt, CO",
      rating: 5,
      text: "Business trip to London with 6 days notice. Fast Passport Center walked me through everything and had my passport in 3 days. No need to drive to Denver through mountain passes in winter.",
      service: "Emergency Passport",
    },
    {
      name: "Sarah D.",
      location: "Aspen, CO — West End",
      rating: 5,
      text: "Lost my passport during Aspen Music Festival week before a trip to Italy. They replaced it in 48 hours. With ASE airport right here, I was able to fly out on schedule.",
      service: "Lost Passport Replacement",
    },
  ],
  facilities: [
    {
      id: "asp-1",
      name: "Aspen Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "235 Puppy Smith St",
      city: "Aspen",
      state: "CO",
      zip: "81611",
      phone: "(970) 925-2120",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Downtown Aspen, near Wagner Park",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Aspen acceptance facility. Appointments required — book 2–3 weeks in advance during ski season. Limited off-season hours.",
      icon: "ri-mail-line",
    },
    {
      id: "asp-2",
      name: "Snowmass Village Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16 Kearns Rd",
      city: "Snowmass Village",
      state: "CO",
      zip: "81615",
      phone: "(970) 923-4220",
      hours: "Mon–Fri: 9:00 AM – 3:00 PM",
      distance: "Snowmass Village, approximately 8 miles from downtown Aspen",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Snowmass Village residents and visitors. Very limited hours — call ahead. Small facility.",
      icon: "ri-mail-line",
    },
    {
      id: "asp-3",
      name: "Basalt Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "101 Midland Ave",
      city: "Basalt",
      state: "CO",
      zip: "81621",
      phone: "(970) 927-3621",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Basalt, approximately 18 miles downvalley from Aspen",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Basalt, El Jebel, and mid-valley communities. Good alternative to Aspen for easier parking.",
      icon: "ri-mail-line",
    },
    {
      id: "asp-4",
      name: "Glenwood Springs Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "113 9th St",
      city: "Glenwood Springs",
      state: "CO",
      zip: "81601",
      phone: "(970) 945-6670",
      hours: "Mon–Fri: 9:00 AM – 4:30 PM",
      distance: "Glenwood Springs, approximately 40 miles downvalley from Aspen",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Largest acceptance facility in the Roaring Fork Valley. Extended hours compared to mountain locations. Good for lower valley residents.",
      icon: "ri-mail-line",
    },
    {
      id: "asp-5",
      name: "Pitkin County Clerk",
      type: "County Clerk Passport Acceptance",
      address: "530 E Main St, Suite 101",
      city: "Aspen",
      state: "CO",
      zip: "81611",
      phone: "(970) 920-5180",
      hours: "Mon–Fri: 8:30 AM – 4:30 PM",
      distance: "Aspen downtown, near the Pitkin County Courthouse",
      website: "https://www.pitkincounty.com/",
      websiteLabel: "Pitkin County Clerk",
      notes: "County clerk passport acceptance. Extended hours compared to post office. Convenient downtown Aspen location.",
      icon: "ri-government-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, 2–3 week wait", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3.5hr drive to Denver over mountain passes", fpc: "No — ship from Aspen" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Winter Road Conditions", agency: "Dangerous I-70 mountain driving", fpc: "No driving needed — courier handles it" },
  ],
  mistakes: [
    {
      icon: "ri-time-line",
      title: "Waiting Until Ski Season",
      description: "Aspen's busiest travel periods — Christmas, Presidents' Week, and spring break — coincide with peak passport demand. Routine processing takes 8–11 weeks. Start expedited service at least 4 weeks before your ski trip.",
    },
    {
      icon: "ri-image-line",
      title: "Wrong Passport Photo",
      description: "Local photo services in Aspen sometimes produce photos for ski passes rather than passports. Passport photos must be exactly 2×2 inches on a white background — no exceptions.",
    },
    {
      icon: "ri-map-pin-2-line",
      title: "Not Booking Acceptance Facilities Early Enough",
      description: "Aspen Post Office appointments fill during peak tourist seasons — summer music festival (June–August) and winter ski season (December–March). Book 2–3 weeks ahead.",
    },
    {
      icon: "ri-snowflake-line",
      title: "Underestimating I-70 Mountain Travel",
      description: "Many Aspen residents attempt to drive to the Denver passport agency in winter. I-70 closures, chain laws, and the 3.5-hour drive each way make this extremely impractical. Our courier service is the smart choice.",
    },
    {
      icon: "ri-global-line",
      title: "Not Checking 6-Month Passport Validity",
      description: "Many European countries require 6 months of passport validity beyond your stay. Aspen travelers heading to the Alps, Mediterranean, or Asia often discover this requirement too late.",
    },
    {
      icon: "ri-flight-takeoff-line",
      title: "Assuming ASE Has International Flights",
      description: "ASE is a domestic-only airport. International Aspen travelers must connect through DEN or a major hub. Always verify passport requirements for your full itinerary, not just the ASE leg.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes — from anywhere in Aspen or the Roaring Fork Valley." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS or FedEx in Aspen, Basalt, or Glenwood Springs." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy — no rejections for high-country documentation errors." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Our registered courier submits to State Department facilities — no 3.5-hour mountain drive required." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Aspen address — trackable every step of the way." },
  ],
  faqs: [
    { q: "How fast can I get an emergency passport in Aspen, CO?", a: "Fast Passport Center offers emergency passport processing in Aspen, Colorado in as little as 24–48 hours. Our registered couriers hand-deliver your documents to U.S. Department of State facilities — no need to make the 160-mile, 3.5-hour drive over mountain passes to the Colorado Passport Agency." },
    { q: "Does Aspen have its own passport agency?", a: "No — Aspen does not have a regional passport agency. The nearest is the Colorado Passport Agency (160 miles east via I-70). Fast Passport Center's courier service means Aspen residents never need to deal with I-70 mountain corridor traffic and weather." },
    { q: "Can I fly internationally directly from Aspen-Pitkin County Airport (ASE)?", a: "ASE is a domestic-only airport with connections to Denver (DEN), Dallas (DFW), Chicago (ORD), Atlanta (ATL), Los Angeles (LAX), San Francisco (SFO), and Houston (IAH). All international travel from Aspen requires a connection through a major hub. Always verify both domestic and international passport requirements." },
    { q: "What if I live in Snowmass Village, Basalt, or Carbondale?", a: "Absolutely. Fast Passport Center serves all of Pitkin County and the entire Roaring Fork Valley including Snowmass Village, Basalt, El Jebel, Carbondale, Glenwood Springs, Redstone, and Marble. Our service works the same way everywhere — ship your documents and we handle the rest." },
    { q: "Can you help with passports for Aspen's seasonal residents?", a: "Yes. Fast Passport Center serves both full-time Pitkin County residents and seasonal/second-home owners. If you split your time between Aspen and another location, we can work with whichever address is most convenient for document delivery." },
    { q: "How much does an expedited passport cost in Aspen, CO?", a: "Government fees are fixed: $130 for a first-time adult passport book or $130 + $60 expedite fee for a renewed adult passport. Fast Passport Center's service fees vary by processing speed. Contact us for a quote based on your specific departure timeline." },
    { q: "Where can I get passport photos in Aspen?", a: "City Market (400 W Main St) offers passport photo services. UPS Store at Aspen Business Center and FedEx Office locations in Glenwood Springs also provide passport photos. Photos must be 2×2 inches on a white background, taken within 6 months." },
    { q: "Does Fast Passport Center serve private jet travelers at ASE?", a: "Yes. Fast Passport Center serves all Pitkin County travelers including private aviation passengers at Aspen-Pitkin County Airport (ASE). We understand the unique needs of private jet travelers and can coordinate expedited passport services to match your departure schedule." },
  ],
  photoLocations: [
    { name: "City Market — Aspen", address: "400 W Main St, Aspen, CO 81611", hours: "Mon–Sun: 6AM–11PM", website: "https://www.kroger.com/" },
    { name: "UPS Store — Aspen Business Center", address: "23286 Two Rivers Rd, Basalt, CO 81621", hours: "Mon–Fri: 8AM–6PM, Sat: 9AM–3PM", website: "https://www.theupsstore.com/" },
    { name: "FedEx Office — Glenwood Springs", address: "51027 Highway 6, Glenwood Springs, CO 81601", hours: "Mon–Fri: 7:30AM–7PM, Sat: 9AM–5PM", website: "https://www.fedex.com/" },
    { name: "Walgreens — Glenwood Springs", address: "40 Market St, Glenwood Springs, CO 81601", hours: "Mon–Sun: 8AM–9PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    { name: "DMV — Glenwood Springs (Garfield County)", address: "107 8th St, Glenwood Springs, CO 81601", hours: "Mon–Fri: 8AM–5PM", note: "Full-service DMV for Pitkin and Garfield County residents. REAL ID and driver's license renewals. Approximately 40 miles from Aspen.", featured: true },
    { name: "DMV — Eagle (Eagle County)", address: "500 Broadway, Eagle, CO 81631", hours: "Mon–Fri: 8AM–5PM", note: "Alternative DMV for downvalley residents near the Eagle County corridor. REAL ID processing available.", featured: false },
  ],
  airports: [
    {
      code: "ASE",
      name: "Aspen-Pitkin County Airport",
      distance: "3 miles from downtown Aspen",
      address: "233 E Airport Rd, Aspen, CO 81611",
      note: "Domestic-only airport serving Aspen and the Roaring Fork Valley. Connections to DEN, DFW, ORD, ATL, LAX, SFO, IAH. All international travel requires a connection through a major hub. Private jet and general aviation services available.",
      flightUrl: "https://www.aspenairport.com/",
      flightLabel: "ASE Flight Info",
      featured: true,
    },
    {
      code: "EGE",
      name: "Eagle County Regional Airport",
      distance: "70 miles from Aspen via Highway 82 and I-70",
      address: "219 Eldon Wilson Rd, Gypsum, CO 81637",
      note: "Regional airport serving Vail and the Roaring Fork Valley. Winter seasonal international flights available. Year-round domestic connections to major hubs.",
      flightUrl: "https://www.eaglecounty.us/airport",
      flightLabel: "EGE Flight Info",
      featured: false,
    },
    {
      code: "DEN",
      name: "Denver International Airport",
      distance: "220 miles from Aspen via I-70 and Highway 82",
      address: "8500 Peña Blvd, Denver, CO 80249",
      note: "Colorado's primary international airport with nonstop flights to Europe, Asia, Mexico, Canada, and domestic destinations. 4-hour drive from Aspen in good conditions.",
      flightUrl: "https://www.flydenver.com/",
      flightLabel: "DEN Flight Info",
      featured: false,
    },
  ],
};